var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      WebkitTransform: "translateY(-3px)",
      msTransform: "translateY(-3px)",
      transform: "translateY(-3px)"
    },
    width: 42,
    height: 42.1,
    viewBox: "0 0 42 42.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_96",
    x: 11.3,
    y: 0,
    width: 30.7,
    height: 30.6,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_97",
    x: 0,
    y: 0.1,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FREE",
    transform: "translate(3 6)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Pfad_96)",
    transform: "matrix(1, 0, 0, 1, -3, -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_96-2",
    "data-name": "Pfad 96",
    className: "cls-1",
    d: "M23.5,20.4v4.2h5.1V19.5H26.5l-.1-5h1.9V9.7L32,5.1h4V0H30.9V2.9L16.4,8V7H11.3v5.1h4.3Zm3,.1h1.1v3.1H24.5V20.5h2Zm.8-7H24.2V10.4h3.1v3.1ZM31.8,1h3.1V4.1H31.8V1Zm-1,2.9v1L27.2,9.4h-4v5.1h2.2l.1,5H24l-7.6-8V9.1ZM12.3,11.1V8h3.1v3.2H12.3Z",
    transform: "translate(3 3)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Pfad_97)",
    transform: "matrix(1, 0, 0, 1, -3, -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_97-2",
    "data-name": "Pfad 97",
    fill: "#f5f5f5",
    d: "M34,18.1h0a16,16,0,1,1-16-16h.1V.1H18a18,18,0,1,0,18,18H34Z",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFree);
export default __webpack_public_path__ + "static/media/free.155a7e941d8f9945ddc5777f81e81656.svg";
export { ForwardRef as ReactComponent };